export default __webpack_public_path__ + "static/media/logo-zut.d81c79b4.jpg";